import util from 'preact-util';

// preact-util's format() turns unset values negative: it derives the sign via
// Math.sign(value) >= 0, and Math.sign(undefined) is NaN, so products without
// granular price segments rendered "-0,00" in every price column. Unset or
// non-numeric values must render as an empty cell instead; -0 collapses to 0
// so an explicit zero can never come out signed.
export function formatPriceCell(value) {
    if (value === undefined || value === null || value === '') {
        return '';
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
        return '';
    }
    return util.format(num, 2, ',', ' ');
}
